import React from 'react';
import FAIcon from 'faIcon';
import DetailsTab from './Tab_MyParties';
import GuestsTab from './Tab_Guests';
import OrdersTab from './Tab_Orders';
import HostRewardsTab from './Tab_HostRewards';
import HostTipsTab from './Tab_HostTips';
import HostPortalActions from './HostPortalActions';

export default class PartyDetailsHeader extends React.Component {
	constructor(props) {
		super(props);
	}

	renderTabContent() {
		switch (this.props.selectedTab) {
			case 'details':
				return <DetailsTab {...this.props} />
				break;
			case 'guests':
				return <GuestsTab {...this.props} />
				break;
			case 'orders':
				return <OrdersTab {...this.props} />
				break;
			case 'rewards':
				return <HostRewardsTab {...this.props} />
				break;
			case 'tips':
				return <HostTipsTab {...this.props} />
				break;
			default:
				return <DetailsTab {...this.props} />
		}
	}

	setTab(tab) {
		HostPortalActions.setTab(tab);
	}

	render() {
		let iconData = {
			Size: 26,
			Fill: "#999999"
		}
		if (this.props.selectedEventDetails == null) return null;
		const guestCount = this.props.selectedEventDetails.guests == null ? 0 : this.props.selectedEventDetails.guests.length;
        const orderCount = this.props.selectedEventDetails.custSharedEventOrders == null ? 0 : this.props.selectedEventDetails.custSharedEventOrders.length;

		return (
			<div className="col-lg-12 clearfix animate-in" style={{float: 'none'}}>
				<div className="clearfix">
					<ul className="nav nav-tabs">
						<li className={this.props.selectedTab === 'details' ? 'active' : ''} onClick={this.setTab.bind(this, 'details')}>
							<a>
								<FAIcon iconData={iconData} name="calendar_check_o" inline={true} styleClass="style02" />&nbsp; {this.props.resources["PWS.MyAccount.PartyDetailsTabMyPartyLabel"]}
							</a>
						</li>
						<li className={this.props.selectedTab === 'guests' ? 'active' : ''} onClick={this.setTab.bind(this, 'guests')}>
							<a>
								<FAIcon iconData={iconData} name="envelope_o" inline={true} />&nbsp; {this.props.resources["PWS.MyAccount.PartyDetailsTabGuestsLabel"]} <span className="badge">{guestCount}</span>
							</a>
						</li>
						<li className={this.props.selectedTab === 'orders' ? 'active' : ''} onClick={this.setTab.bind(this, 'orders')}>
							<a>
								<FAIcon iconData={iconData} name="shopping_cart" inline={true} />&nbsp; {this.props.resources["PWS.MyAccount.PartyDetailsTabOrdersLabel"]} <span className="badge">{orderCount}</span>
							</a>
						</li>
						<li className={this.props.selectedTab === 'rewards' ? 'active' : ''} onClick={this.setTab.bind(this, 'rewards')}>
							<a>
								<FAIcon iconData={iconData} name="gift" inline={true} />&nbsp; {this.props.resources["PWS.MyAccount.PartyDetailsTabHostRewardsLabel"]}
							</a>
						</li>
						<li className={this.props.selectedTab === 'tips' ? 'active' : ''} onClick={this.setTab.bind(this, 'tips')}>
							<a>
								<FAIcon iconData={iconData} name="lightbulb_o" inline={true} />&nbsp; {this.props.resources["PWS.MyAccount.PartyDetailsTabHostTipsLabel"]}
							</a>
						</li>
					</ul>
				</div>
				<div className="tab-content clearfix">
					<div className="tab-pane active clearfix">
						{this.renderTabContent()}
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/PartyDetailsTabContainer.js